/* Guide answers stay in this component. Only catalog pages are fetched. */
(() => {
  'use strict';
  // AAshop 15/10-2026: engelsk visning på /en-eu og /en-se (html lang="en"). Kun viste tekster; svar-id'er og data er uændrede.
  const AA_EN = !/^da\b/i.test(document.documentElement.lang || 'da');
  const tx = (da, en) => (AA_EN ? en : da);
  const EN_FACTS = {lige: 'even', hovedtung: 'head-heavy', hovedlet: 'head-light', stiv: 'stiff', medium: 'medium', fleksibel: 'flexible'};
  const fact = value => (!AA_EN || typeof value !== 'string' ? value
    : Object.prototype.hasOwnProperty.call(EN_FACTS, value) ? EN_FACTS[value]
    : value.replace(/ eller /g, ' or ').replace('variant ikke angivet hos AAshop', 'variant not specified at AAshop').replace(/\bca\. /g, 'approx. '));
  const EN_QUESTIONS = {
    audience: ['Your level', 'Who will use the racket?', 'We start by finding the right type of racket.', {
      junior: ['Junior', 'A racket for a younger player.', 'Junior'],
      beginner: ['Adult, recreational and beginner', 'I am new to badminton or play for fun.', 'Recreational and beginner'],
      club: ['Adult, club player', 'I play badminton regularly.', 'Club player']}],
    style: ['Your game', 'How do you prefer to play?', 'Think about the shots and situations you enjoy most.', {
      attack: ['Attack and hard smashes', 'I like to put my opponent under pressure.', 'Attack and smashes'],
      speed: ['Fast play at the net and defence', 'I thrive at the net and in fast rallies.', 'Fast play'],
      allround: ['A bit of everything', 'I want a versatile racket.', 'A bit of everything']}],
    weight: ['Weight', 'Which weight do you prefer?', 'The weight is part of how the racket feels in your hand.', {
      light: ['Light and fast', 'I prefer a light racket.', 'Light racket'],
      heavy: ['A little more weight', 'I like more weight in my hand.', 'More weight'],
      any: ['Not sure', 'Let the other answers decide.', 'Weight: open']}],
    flex: ['Shaft', 'What do you prefer in the shaft?', 'If you are unsure, you can safely choose "Not sure".', {
      flexible: ['Flexible', 'Helps with power in the shot.', 'Flexible shaft'],
      stiff: ['Stiff', 'For fast and precise technique.', 'Stiff shaft'],
      any: ['Not sure', 'Let the other answers decide.', 'Shaft: open']}],
    budget: ['Your budget', 'What is your budget?', 'We prioritise the price you choose and show any differences.', {
      under500: ['Up to DKK 500', '', 'Up to DKK 500'],
      mid: ['DKK 500 to 1,000', '', 'DKK 500 to 1,000'],
      over1000: ['Over DKK 1,000', '', 'Over DKK 1,000'],
      any: ['Does not matter', '', 'All prices']}]
  };
  async function initialize(root) {
  if (root.dataset.guideInitialized) return;
  root.dataset.guideInitialized = 'true';
  let products = [];
  const $ = selector => root.querySelector(selector);
  const esc = value => String(value ?? '').replace(/[\u2013\u2014]/g, ', ').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
  const check = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="m4 10 4 4 8-8"/></svg>';
  const edit = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="m4 12 9-9 4 4-9 9H4v-4Zm7-7 4 4"/></svg>';
  const money = value => new Intl.NumberFormat('da-DK', {maximumFractionDigits:2}).format(value) + ' kr.';
  const questions = [
    {key:'audience', name:'Dit niveau', title:'Hvem skal ketcheren bruges af?', help:'Vi starter med at finde den rigtige type ketcher.', options:[
      ['junior','Junior','En ketcher til den yngre spiller.','Junior'],
      ['beginner','Voksen, fritid og begynder','Jeg er ny i badminton eller spiller for hyggens skyld.','Fritid og begynder'],
      ['club','Voksen, spiller i klub','Jeg spiller badminton regelmæssigt.','Klubspiller']
    ]},
    {key:'style', name:'Dit spil', title:'Hvordan spiller du helst?', help:'Tænk på de slag og situationer, du bedst kan lide.', options:[
      ['attack','Angreb og hårde smash','Jeg vil gerne sætte modstanderen under pres.','Angreb og smash'],
      ['speed','Hurtigt spil foran nettet og forsvar','Jeg trives foran nettet og i de hurtige dueller.','Hurtigt spil'],
      ['allround','Lidt af det hele','Jeg vil gerne have en alsidig ketcher.','Lidt af det hele']
    ]},
    {key:'weight', name:'Vægt', title:'Hvilken vægt foretrækker du?', help:'Vægten er en del af, hvordan ketcheren føles i hånden.', options:[
      ['light','Let og hurtig','Jeg foretrækker en let ketcher.','Let ketcher'],
      ['heavy','Lidt mere tyngde','Jeg kan godt lide mere vægt i hånden.','Mere tyngde'],
      ['any','Ved ikke','Lad de andre svar afgøre det.','Vægt: åben']
    ]},
    {key:'flex', name:'Skaft', title:'Hvad foretrækker du i skaftet?', help:'Er du i tvivl, kan du roligt vælge "Ved ikke".', options:[
      ['flexible','Fleksibelt','Hjælper med kraften i slaget.','Fleksibelt skaft'],
      ['stiff','Stift','Til hurtig og præcis teknik.','Stift skaft'],
      ['any','Ved ikke','Lad de andre svar afgøre det.','Skaft: åbent']
    ]},
    {key:'budget', name:'Dit budget', title:'Hvad er dit budget?', help:'Vi prioriterer prisen, du vælger, og viser eventuelle afvigelser.', options:[
      ['under500','Op til 500 kr.','','Op til 500 kr.'],
      ['mid','500 til 1.000 kr.','','500 til 1.000 kr.'],
      ['over1000','Over 1.000 kr.','','Over 1.000 kr.'],
      ['any','Ligegyldigt','','Alle priser']
    ]}
  ];
  if (AA_EN) for (const question of questions) {
    const [name, title, help, options] = EN_QUESTIONS[question.key];
    Object.assign(question, {name, title, help});
    question.options = question.options.map(([value]) => [value, ...options[value]]);
  }
  let answers = {};
  let step = 0;
  let hasResults = false;

  function showScreen(screen) {
    $('#guide-intro').hidden = screen !== 'intro';
    $('#guide-intro-bottom').hidden = screen !== 'intro';
    $('#guide-flow').hidden = screen !== 'flow';
    $('#guide-results').hidden = screen !== 'results';
  }

  function focusScreen(element) {
    const mainTop = root.getBoundingClientRect().top + window.scrollY;
    const headerHeight = document.querySelector('header.header, .shopify-section--header')?.offsetHeight || 0;
    window.scrollTo({top:Math.max(0, mainTop - headerHeight), behavior:'auto'});
    element.focus({preventScroll:true});
  }

  function renderStep(index) {
    step = index;
    const question = questions[index];
    showScreen('flow');
    $('#guide-step-label').textContent = AA_EN ? `QUESTION ${index + 1} OF ${questions.length}` : `SPØRGSMÅL ${index + 1} AF ${questions.length}`;
    $('#guide-step-name').textContent = question.name.toLocaleUpperCase('da-DK');
    $('#guide-progress').setAttribute('aria-valuenow', String(index + 1));
    $('#guide-progress').setAttribute('aria-valuetext', AA_EN ? `Question ${index + 1} of ${questions.length}: ${question.name}` : `Spørgsmål ${index + 1} af ${questions.length}: ${question.name}`);
    $('#guide-progress > span').style.width = ((index + 1) / questions.length * 100) + '%';
    $('#guide-question-title').textContent = question.title;
    $('#guide-question-help').textContent = question.help;
    $('#guide-options').dataset.question = question.key;
    $('#guide-options').innerHTML = question.options.map(([value, title, description]) => `<label class="guide-option"><input type="radio" name="${question.key}" value="${value}" ${answers[question.key] === value ? 'checked' : ''} aria-describedby="guide-description-${value}"><span class="guide-option-mark" aria-hidden="true"></span><span class="guide-option-text"><strong>${esc(title)}</strong><small id="guide-description-${value}">${esc(description)}</small></span></label>`).join('');
    $('#guide-step-list').innerHTML = questions.map((item, i) => `<li ${i === index ? 'aria-current="step"' : ''} class="${answers[item.key] && i !== index ? 'is-complete' : ''}"><span>${answers[item.key] && i !== index ? check : '0' + (i + 1)}</span>${esc(item.name)}</li>`).join('');
    $('#guide-next').disabled = !answers[question.key];
    $('#guide-next > span').textContent = index === questions.length - 1 ? tx('Se mine ketchere', 'See my rackets') : tx('Fortsæt', 'Continue');
    focusScreen($('#guide-question-title'));
  }

  function resultCard(result, index) {
    const p = result.product;
    const facts = [p.balance, p.weight, p.flex].filter(Boolean).map(fact);
    const reasons = result.reasons || [];
    const differences = result.differences || [];
    const missing = result.missing || [];
    const sources = result.sources || [];
    const rank = result.exact ? tx('MATCHER DINE VALG', 'MATCHES YOUR CHOICES') : index === 0 ? tx('TÆTTEST PÅ DINE SVAR', 'CLOSEST TO YOUR ANSWERS') : tx('ET ANDET BUD', 'ANOTHER OPTION');
    const sourceList = sources.map(source => `<li><a href="${esc(source.url)}" target="_blank" rel="noopener noreferrer">${esc(source.label || source.field)}</a><span>${esc(source.type === 'producent' ? tx('Producent', 'Manufacturer') : source.type === 'forhandler' ? tx('Forhandler', 'Retailer') : source.type)}</span></li>`).join('');
    const sourceFallback = /^https?:\/\//.test(p.source_url || '') ? `<li><a href="${esc(p.source_url)}" target="_blank" rel="noopener noreferrer">${tx('Se produktets specifikationer', 'See the product specifications')}</a></li>` : '';
    return `<article class="guide-result-card" data-product="${esc(p.handle)}"><a class="guide-result-image" href="${esc(p.url)}" tabindex="-1" aria-hidden="true"><div class="guide-result-rank"><span>${index + 1}</span>${rank}</div><img src="${esc(p.image)}" alt="" width="700" height="900" loading="eager"></a><div class="guide-result-body"><p class="guide-result-brand">${esc(p.brand)}</p><h2><a href="${esc(p.url)}">${esc(p.titel)}</a></h2><p class="guide-result-price">${money(p.price)}</p><div class="guide-facts" aria-label="${tx('Specifikationer', 'Specifications')}">${facts.map(fact => `<span>${esc(fact)}</span>`).join('')}</div><p class="guide-reasons-title">${tx('Derfor er den med', 'Why it is included')}</p><ul class="guide-reasons">${reasons.map(reason => `<li>${check}<span>${esc(reason)}</span></li>`).join('')}</ul>${differences.length ? `<div class="guide-differences"><strong>${tx('Vær opmærksom på', 'Please note')}</strong><ul>${differences.map(difference => `<li>${esc(difference)}</li>`).join('')}</ul></div>` : ''}${missing.length ? `<p class="guide-missing">${esc(missing.join(' '))}</p>` : ''}<div class="guide-card-footer"><details class="guide-sources"><summary>${tx('Se specifikationernes kilder', 'See the sources for the specifications')}</summary><p class="guide-source-note">${esc(result.sourceSummary || '')}</p><ul>${sourceList || sourceFallback}</ul>${p.source_note ? `<p class="guide-source-note">${esc(p.source_note)}</p>` : ''}</details><a class="button guide-primary guide-product-cta" href="${esc(p.url)}">${tx('Se ketcheren hos AAshop', 'See the racket at AAshop')} ${arrow}</a></div></div></article>`;
  }

  function renderResults() {
    const result = window.KetcherGuide.recommend(products, answers);
    hasResults = true;
    const recommendations = result.recommendations;
    $('#guide-results-title').textContent = recommendations.length === 0 ? tx('INGEN KETCHERE TIL DINE VALG', 'NO RACKETS FOR YOUR CHOICES') : recommendations.length === 1 ? tx('EN KETCHER TIL DIG', 'A RACKET FOR YOU') : tx('KETCHERE TIL DIG', 'RACKETS FOR YOU');
    $('#guide-results-intro').textContent = recommendations.length === 0 ? tx('Vi har ikke en købbar ketcher med de nødvendige oplysninger til dine svar lige nu.', 'We do not have a racket in stock with the information needed for your answers right now.') : recommendations.length === 1 ? tx('Her er den ketcher i udvalget, der kommer tættest på dine svar.', 'Here is the racket in the range that comes closest to your answers.') : AA_EN ? `Here are ${recommendations.length} rackets to look at more closely, based on your answers.` : `Her er ${recommendations.length} ketchere, du kan kigge nærmere på, ud fra dine svar.`;
    $('#guide-answer-summary').innerHTML = questions.map((question, index) => {
      const option = question.options.find(item => item[0] === answers[question.key]);
      return `<button type="button" data-edit-step="${index}" aria-label="${tx('Redigér', 'Edit')} ${esc(question.name.toLocaleLowerCase('da-DK'))}: ${esc(option[3])}">${esc(option[3])}${edit}</button>`;
    }).join('');
    $('#guide-results-notice').textContent = (result.notice || '').replace('i snapshottet', 'i udvalget');
    $('#guide-result-grid').innerHTML = recommendations.map(resultCard).join('');
    showScreen('results');
    focusScreen($('#guide-results-title'));
  }

  $('#guide-start').addEventListener('click', () => { if (!$('#guide-start').disabled) renderStep(0); });
  $('#guide-options').addEventListener('change', event => {
    if (event.target.matches('input[type="radio"]')) {
      answers[questions[step].key] = event.target.value;
      $('#guide-next').disabled = false;
    }
  });
  $('#guide-form').addEventListener('submit', event => {
    event.preventDefault();
    if (!answers[questions[step].key]) return;
    if (step === questions.length - 1) renderResults();
    else renderStep(step + 1);
  });
  $('#guide-back').addEventListener('click', () => {
    if (step > 0) renderStep(step - 1);
    else if (hasResults) renderResults();
    else { showScreen('intro'); focusScreen($('#guide-title')); }
  });
  $('#guide-restart').addEventListener('click', () => { answers = {}; hasResults = false; renderStep(0); });
  $('#guide-edit').addEventListener('click', () => renderStep(0));
  $('#guide-answer-summary').addEventListener('click', event => {
    const button = event.target.closest('[data-edit-step]');
    if (button) renderStep(Number(button.dataset.editStep));
  });

  function readPayload(node) {
    const script = node.querySelector('[data-guide-data]');
    if (!script) throw new Error('Catalog data is missing');
    const payload = JSON.parse(script.textContent);
    if (!Array.isArray(payload.products) || !Number.isInteger(payload.expected) || payload.expected < 0) throw new Error('Catalog data is invalid');
    return payload;
  }

  async function fetchPage(page, initial) {
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || ['sort_by', 'page', 'section_id', 'sections'].includes(key)) url.searchParams.delete(key);
    }
    url.hash = '';
    url.searchParams.set(initial.pageParam || 'page', String(page));
    url.searchParams.set('sections', root.dataset.sectionId);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal, headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Catalog request failed');
      const sections = await response.json();
      const markup = sections[root.dataset.sectionId];
      if (typeof markup !== 'string') throw new Error('Catalog section is missing');
      const fragment = new DOMParser().parseFromString(markup, 'text/html');
      const data = readPayload(fragment);
      if (data.page !== page || data.expected !== initial.expected || data.currency !== initial.currency || data.country !== initial.country) throw new Error('Catalog changed while loading');
      return data;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function loadCatalog(initial) {
    if (!initial.expected) throw new Error('The collection is empty');
    let first = initial;
    // A filtered collection page is never accepted as the complete catalog.
    if (initial.items !== initial.expected) first = await fetchPage(1, initial);
    if (first.items !== first.expected || !Number.isInteger(first.pages) || first.pages < 1 || first.pages > 100) throw new Error('Catalog pagination is incomplete');
    const records = [...first.products];
    for (let page = 1; page <= first.pages; page += 1) {
      if (page === first.page) continue;
      const additional = await fetchPage(page, first);
      if (additional.pages !== first.pages || additional.items !== first.items) throw new Error('Catalog pagination changed');
      records.push(...additional.products);
    }
    const seen = new Set();
    for (const record of records) {
      if (!record.id || seen.has(record.id)) throw new Error('Duplicate or missing product identifier');
      seen.add(record.id);
    }
    if (seen.size !== first.expected) throw new Error('Not every product was loaded');
    // Specs never override price, availability, image or the selected variant URL.
    return records.map(record => ({...(record.specs && typeof record.specs === 'object' ? record.specs : {}), ...record}));
  }

  try {
    const initial = readPayload(root);
    if (!initial.expected) throw new Error('The collection is empty');
    if (initial.currency !== 'DKK' || initial.country !== 'DK') {
      $('[data-guide-status]').textContent = tx('Ketcherguiden bruger danske priser og budgetter. Vælg Danmark i butikkens landevælger for at bruge testen. Du kan også se alle ketchere nedenfor.', 'The racket guide uses Danish prices and budgets. Choose Denmark in the shop\'s country selector to use the test. You can also see all rackets below.');
      $('#guide-start').hidden = true;
      root.dataset.guideState = 'market';
      return;
    }
    if (!window.KetcherGuide) throw new Error('Recommendation engine is missing');
    products = await loadCatalog(initial);
    root.dataset.productCount = String(products.length);
    root.dataset.guideState = 'ready';
    $('[data-guide-status]').textContent = '';
    $('#guide-start').disabled = false;
  } catch (error) {
    $('[data-guide-status]').textContent = tx('Vi kunne ikke hente hele udvalget lige nu. Prøv at genindlæse siden, eller se alle ketchere nedenfor.', 'We could not load the full range right now. Try reloading the page, or see all rackets below.');
    $('#guide-start').hidden = true;
    root.dataset.guideState = 'error';
  }
  }
  function boot(scope) {
    scope.querySelectorAll('[data-aashop-guide]').forEach(initialize);
  }
  if (!window.aashopKetcherGuideBoot) {
    window.aashopKetcherGuideBoot = true;
    document.addEventListener('shopify:section:load', event => boot(event.target));
  }
  boot(document);
})();
